/**
 * FastAPI returns `detail` as a plain string for most app-level errors
 * (401/403/404/429), but as an ARRAY of Pydantic validation-error objects
 * for 422 responses (e.g. a field exceeding a max_length, or an invalid
 * email format). Blindly passing that array into a toast would render
 * "[object Object]" instead of a useful message — this normalizes both
 * shapes into a single readable string.
 */
export function getErrorMessage(err, fallback = 'Something went wrong. Please try again.') {
  const detail = err?.response?.data?.detail;
  if (typeof detail === 'string') return detail;
  if (Array.isArray(detail) && detail.length > 0 && typeof detail[0]?.msg === 'string') {
    return detail[0].msg;
  }
  return fallback;
}
